export default __webpack_public_path__ + "static/media/34-min.31cc4305.jpg";